import React from "react";
import { Button, Tooltip } from "antd";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import COLORS from "common/Colors";
import styled from "styled-components";

const PRIMARY = COLORS.PRIMARY;
const PRIMARY_DARK = "#1F3FB0";

const FloatingButton = styled(Button)`
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 1000;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%);
  box-shadow: 0 10px 28px rgba(45, 83, 218, 0.4);
  transition: transform .15s ease, box-shadow .15s ease;

  &:hover, &:focus {
    background: linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%) !important;
    transform: translateY(-2px);
    box-shadow: 0 14px 32px rgba(45, 83, 218, 0.48);
  }

  .anticon, svg { color: #fff; font-size: 24px; }
`;

// Opens the AI Resume Ranker modal (owned by JobsList) via the ranking
// context's openModal callback — this button no longer has its own chat
// panel, the chat now lives docked inside that modal (RecruitmentChatPanel).
function RecruitmentAIChatbot({ rankingContext }) {
  return (
    <Tooltip title="Recruitment AI">
      <FloatingButton
        onClick={() => rankingContext?.openModal?.()}
        icon={<SmartToyOutlinedIcon />}
      />
    </Tooltip>
  );
}

export default RecruitmentAIChatbot;
